<template>
  <div class="social-share-bar__desktop">
    <s-facebook
      class="social-share-bar__desktop__link"
      :share-options="{
        url: url,
        quote: quote,
        hashtags: hashtags,
      }"
    >
      <SocialIconFacebookBlack />
    </s-facebook>
    <s-pinterest
      class="social-share-bar__desktop__link"
      :share-options="{
        url: url,
        description: quote,
      }"
    >
      <SocialIconPinterestBlack />
    </s-pinterest>
    <s-whats-app
      class="social-share-bar__desktop__link"
      :share-options="{
        text: whatsappMessage,
      }"
    >
      <SocialIconWhatsAppBlack />
    </s-whats-app>
    <div class="social-share-bar__desktop__link">
      <LinkBlack
        class="social-share-bar__desktop__copy"
        @click="copyToClipboard"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import {
  SocialIconFacebookBlack,
  SocialIconPinterestBlack,
  SocialIconTwitterBlack,
  SocialIconWhatsAppBlack,
  LinkBlack,
  ShareBlack,
} from '~/components/General/Icons';
import { SFacebook, SPinterest, STwitter, SWhatsApp } from 'vue-socials';
import { useUiNotification } from '~/composables';
import { useI18n } from '~/helpers/hooks/usei18n';

export default defineComponent({
  name: 'SocialShareBarDesktop',
  components: {
    SocialIconFacebookBlack,
    SocialIconPinterestBlack,
    SocialIconTwitterBlack,
    SocialIconWhatsAppBlack,
    SFacebook,
    SPinterest,
    STwitter,
    SWhatsApp,
    LinkBlack,
    ShareBlack,
  },
  props: {
    url: {
      type: String,
      default: 'www.sognidicristallo.com',
    },
    quote: {
      type: String,
      default: 'Sogni di Cristallo',
    },
    hashtags: {
      type: String,
      default: 'sognidicristallo',
    },
  },
  setup(props) {
    const { send: sendNotification } = useUiNotification();
    const trans = useI18n();
    const whatsappMessage = computed(() => {
      try {
        return decodeURIComponent(props.url);
      } catch (error) {
        console.error(
          'SocialShareBarDesktop - whatsappMessage - error:',
          error
        );
      }
      return props.url;
    });

    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(props.url);
        sendNotification({
          id: Symbol('social_share_copy_success'),
          message: trans.t('Link copied.'),
          type: 'success',
          icon: 'success',
          persist: false,
          title: 'Success',
        });
      } catch (error) {
        sendNotification({
          id: Symbol('social_share_copy_error'),
          message: trans.t('An error occurred while copying the link.'),
          type: 'danger',
          icon: 'error',
          persist: false,
          title: 'Error',
        });
        console.error('Failed to copy URL:', error);
      }
    };

    return {
      copyToClipboard,
      whatsappMessage,
    };
  },
});
</script>

<style lang="scss" scoped>
.social-share-bar__desktop {
  display: none;
}
@include from-desktop-min {
  .social-share-bar__desktop {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    &__copy {
      @include pointer;
    }
    &__twitter {
      display: none;
    }
    &__link {
      scale: 0.9;
    }
  }
}
</style>
